import { Markdown, Typography } from '@altify/components';
import { MARKDOWN_STYLES } from '../constants/styles';

interface MarkdownSectionProps {
  title: string;
  content: string;
}

/**
 * Renders a titled markdown section
 */
export function MarkdownSection({ title, content }: MarkdownSectionProps) {
  return (
    <>
      <Typography size="medium" weight="medium">
        {title}
      </Typography>
      <Markdown styles={MARKDOWN_STYLES}>{content}</Markdown>
    </>
  );
}
